const isAdwayEmail = user => {
  return user && user.email && user.email.substring(user.email.lastIndexOf("@") + 1) === "adway.ai";
};

export default isAdwayEmail;
